// extracted by mini-css-extract-plugin
module.exports = {"iconOnly":"BackButton__iconOnly--1gK","generic":"BackButton__generic--1DF","rounded":"BackButton__rounded--eYd"};